import { motion } from "framer-motion";

// Masked line-by-line reveal
export const lineParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.1 } },
};
export const lineChild = {
  hidden: { y: "110%" },
  show: { y: 0, transition: { duration: 0.85, ease: [0.76, 0, 0.24, 1] } },
};

export function MaskLine({ children, className = "" }) {
  return (
    <span className="block overflow-hidden">
      <motion.span variants={lineChild} className={`block ${className}`}>
        {children}
      </motion.span>
    </span>
  );
}

// Generic scroll reveal
export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    >
      {children}
    </motion.div>
  );
}
